// external imports
import React, { useEffect, useContext, useState } from 'react';
import Skeleton from 'react-loading-skeleton';

// internal imports
import { QCImageSmelter } from '../maps/QCImageSmelter';
import { QCImageComparisonSmelter } from '../maps/QCImageComparisonSmelter';
import { endpointContext } from '../../contexts/endpointContext';
import useGainsQCApi from '../../services/useGainsQCApi';
import exportConfig from '../../config';
import { commentsData, commentTypes } from '../../data/captureCommentsExample';

const CaptureModal = ({
	currentImage,
	setCurrentImage,
	siteType,
	comments,
	user
}) => {
	const fetchCaptureData = useGainsQCApi();
	const endpointContextSites = useContext(endpointContext);

	const thisSite = endpointContextSites?.dbData?.gainsSites?.find(
		(site) => site.id === currentImage?.site_id
	);
	const editCommentData = useGainsQCApi();

	const [formValid, setFormValid] = useState(false);
	const initialCommentFormValue = {
		comment_type: 'Comment',
		comment_text: '',
		resolved: false,
		user: user,
		datetime: new Date().toISOString().slice(0, 19).replace('T', ' ')
	};
	const [commentFormValue, setCommentFormValue] = useState(
		initialCommentFormValue
	);

	const addCommentToCapture = (e) => {
		e.preventDefault();

		//setComments((prevComments) => [...prevComments, commentFormValue]);

		setCommentFormValue(initialCommentFormValue);
	};

	const resolveComment = async (commentId) => {
		// await editCommentData.makeRequest(
		// 	'/capture_comments',
		// 	'PUT',
		// 	{
		// 		comment_id: commentId,
		// 		resolved
		// 		resolved: 'true',
		// 	}
		// )
	};

	useEffect(() => {
		let siteTypeStr = exportConfig.siteTypesIds.filter(
			(site) => site.id === siteType
		)[0]?.name;

		if (!currentImage || !currentImage?.['stac_item_id']) {
			return;
		}

		fetchCaptureData.makeRequest(
			`/${siteTypeStr}/capture_image?stacItemId=${currentImage.stac_item_id}&sensor=${currentImage.sensor}&siteId=${currentImage.site_id}`,
			'GET',
			null,
			`capture ${currentImage.id}`
		);

		return () => {
			fetchCaptureData.resetData();
		};
	}, [currentImage]);

	return (
		<div
			className="modal modal-xl fade"
			id="captureModal"
			tabindex="-1"
			aria-labelledby="captureModalLabel"
			aria-hidden="true"
			style={{ marginTop: '80px' }}
		>
			<div
				className="modal-dialog"
				style={{ width: '85vw', marginLeft: '10%' }}
			>
				<div className="modal-content" style={{ width: '70vw' }}>
					<div
						className="modal-header text-light"
						style={{ backgroundColor: 'rgb(48, 48, 48)' }}
					>
						{currentImage ? (
							<h5 className="modal-title" id="exitQCModalLabel">
								Capture {currentImage.id}
							</h5>
						) : (
							<Skeleton width={30} />
						)}
					</div>

					<div
						class="modal-body"
						style={{ maxHeight: '800px', overflowY: 'auto' }}
					>
						{siteType === 1 ? (
							<>
								{/* images row */}
								<div className="row">
									<div className="col" style={{ height: '400px' }}>
										{fetchCaptureData?.data?.data ? (
											<QCImageSmelter
												imageData={fetchCaptureData.data}
												modalId={'whatever'}
												imageUrl={fetchCaptureData?.data?.data?.true_color}
												openModal={false}
												loading={false}
												showHotspots={true}
											/>
										) : (
											<Skeleton width={'100%'} height={'400px'} />
										)}
									</div>
									<div className="col" style={{ height: '400px' }}>
										{fetchCaptureData?.data?.data ? (
											<QCImageSmelter
												imageData={fetchCaptureData.data}
												modalId={'whatever2'}
												imageUrl={fetchCaptureData?.data?.data?.ratio}
												openModal={false}
												loading={false}
											/>
										) : (
											<Skeleton width={'100%'} height={'400px'} />
										)}
									</div>
									<div className="col" style={{ height: '400px' }}>
										{fetchCaptureData?.data?.data ? (
											<QCImageSmelter
												imageData={fetchCaptureData.data}
												modalId={'whateve3'}
												imageUrl={fetchCaptureData?.data?.data?.comp}
												openModal={false}
												loading={false}
											/>
										) : (
											<Skeleton width={'100%'} height={'400px'} />
										)}
									</div>
								</div>

								{/* capture info row */}
								<div className="row my-4">
									<div className="col p-3" style={{ height: 'auto' }}>
										<h5 className="text-center">Site Info</h5>
										<table className="capture-id-table">
											<tbody>
												<tr>
													<td>Site ID</td>
													<td>
														{currentImage ? currentImage.site_id : <Skeleton />}
													</td>
												</tr>

												<tr>
													<td>Site Name</td>
													<td>
														{currentImage ? (
															currentImage.site_name
														) : (
															<Skeleton />
														)}
													</td>
												</tr>

												<tr>
													<td>Site Type</td>
													<td>{thisSite?.stype}</td>
												</tr>

												<tr>
													<td>Commodity</td>
													<td>
														{
															exportConfig.commodities?.find(
																(com) => com.index === thisSite?.commodity_id
															)?.commodity
														}
													</td>
												</tr>

												<tr>
													<td>Capacity</td>
													<td>{thisSite?.params?.capacity}</td>
												</tr>

												<tr>
													<td>Country</td>
													<td>{thisSite?.country}</td>
												</tr>

												<tr>
													<td>Region</td>
													<td>{thisSite?.region}</td>
												</tr>

												<tr>
													<td>Plant Type</td>
													<td>{thisSite?.params?.plant_type}</td>
												</tr>
											</tbody>
										</table>
									</div>
									<div className="col p-3" style={{ height: 'auto' }}>
										<h5 className="text-center">Capture Info</h5>
										<table className="capture-id-table">
											<tbody>
												<tr>
													<td>Capture ID</td>
													<td>
														{currentImage ? currentImage.id : <Skeleton />}
													</td>
												</tr>

												<tr>
													<td>Sensor</td>
													<td>
														{currentImage ? currentImage.sensor : <Skeleton />}
													</td>
												</tr>

												<tr>
													<td>Initial State</td>
													<td>
														{currentImage ? (
															<span
																className={
																	exportConfig.qcStates.filter(
																		(state) =>
																			state.stateInt ===
																			currentImage.initial_state
																	)[0].className
																}
															>
																{
																	exportConfig.qcStates.filter(
																		(state) =>
																			state.stateInt ===
																			currentImage.initial_state
																	)[0].stateString
																}
															</span>
														) : (
															<Skeleton />
														)}
													</td>
												</tr>

												<tr>
													<td>Final State</td>
													<td>
														{currentImage ? (
															<>
																{currentImage.state
																	? exportConfig.qcStates.filter(
																			(state) =>
																				state.stateInt === currentImage.state
																		)[0].stateString
																	: '-'}
															</>
														) : (
															<Skeleton />
														)}
													</td>
												</tr>

												<tr>
													<td>Hotspot Count</td>
													<td>
														{currentImage ? (
															currentImage.hotspots
														) : (
															<Skeleton />
														)}
													</td>
												</tr>

												<tr>
													<td>Cloud Fraction</td>
													<td>{currentImage?.cloud_frac}</td>
												</tr>

												<tr>
													<td>Max Band Ratio</td>
													<td>
														{currentImage && currentImage.max_band_ratio ? (
															currentImage.max_band_ratio.toFixed(2)
														) : (
															<>-</>
														)}
													</td>
												</tr>

												<tr>
													<td>Invalid Data Frac</td>
													<td>
														{currentImage ? (
															(currentImage.invalid_data_frac ?? '-')
														) : (
															<Skeleton />
														)}
													</td>
												</tr>
											</tbody>
										</table>
									</div>

									<div className="col p-3" style={{ height: 'auto' }}>
										<h5 className="text-center">QC Info</h5>
										<table className="capture-id-table">
											<tbody>
												<tr>
													<td>QC'd</td>
													{currentImage ? (
														<>
															{exportConfig.qcStages.filter(
																(stage) => stage.id === currentImage.qc_state
															)[0].qcd ? (
																<td>
																	<i className="fa-solid fa-check"></i>
																</td>
															) : (
																<td>
																	<i className="fa-solid fa-circle-xmark"></i>
																</td>
															)}
														</>
													) : (
														<td>
															<Skeleton />
														</td>
													)}
												</tr>

												<tr>
													<td>QC Date</td>
													<td>
														{currentImage ? (
															<>
																{' '}
																{exportConfig.qcStages.filter(
																	(stage) => stage.id === currentImage.qc_state
																)[0].qcd
																	? currentImage.qc_date
																	: '-'}
															</>
														) : (
															<Skeleton />
														)}
													</td>
												</tr>

												<tr>
													<td>QC User</td>
													<td>
														{currentImage ? (
															<>
																{exportConfig.qcStages.filter(
																	(stage) => stage.id === currentImage.qc_state
																)[0].qcd
																	? currentImage.qc_user
																	: '-'}
															</>
														) : (
															<Skeleton />
														)}
													</td>
												</tr>

												<tr>
													<td></td>
													<td></td>
												</tr>

												<tr>
													<td></td>
													<td></td>
												</tr>

												{/* <tr>
													<td>QC Report</td>
													<td>
														{currentImage ? (
															<>
																{exportConfig.qcStages.filter(
																	(stage) => stage.id === currentImage.qc_state
																)[0].qcd ? (
																	<i
																		id="captureImageHover"
																		className="fa-regular fa-file ms-2"
																	></i>
																) : (
																	'-'
																)}{' '}
															</>
														) : (
															<Skeleton />
														)}
													</td>
												</tr> */}
											</tbody>
										</table>
									</div>
								</div>

								{comments && comments.length > 0 && (
									<div className="row my-3">
										<div className="col p-3">
											<h5 className="text-center">
												Capture Comments{' '}
												{/* <i className="fa-solid fa-wrench text-warning "></i> */}
											</h5>
											<div className="table-responsive mt-4">
												<table className="captureCommentsTable">
													<thead>
														<tr>
															<th>Date</th>
															<th>Raised by</th>
															<th>Type</th>
															<th>Comment</th>
															<th>Resolved</th>
															<th>Resolved by</th>
															<th>Resolved comment</th>
															<th>Resolved datetime</th>
															<th>Mark as resolved?</th>
														</tr>
													</thead>

													<tbody>
														{comments.map((comment, idx) => (
															<tr key={idx}>
																<td>{comment.datetime}</td>
																<td>{comment.raised_by}</td>
																<td>{comment.comment_type}</td>
																<td>{comment.comment_text}</td>
																<td className="text-center">
																	{comment.resolved ? (
																		<i className="fa-solid fa-circle-check"></i>
																	) : (
																		'-'
																	)}
																</td>
																<td>
																	{comment.resolved ? (
																		<>{comment.resolved_by}</>
																	) : (
																		'-'
																	)}
																</td>

																<td>
																	{comment.resolved ? (
																		<>{comment.resolved_comment}</>
																	) : (
																		'-'
																	)}
																</td>

																<td>
																	{comment.resolved ? (
																		<>{comment.resolved_datetime}</>
																	) : (
																		'-'
																	)}
																</td>

																<td>
																	<div class="form-check form-switch">
																		<input
																			onClick={(e) =>
																				resolveComment(comment.comment_id)
																			}
																			class="form-check-input"
																			type="checkbox"
																			id="resolvedToggle"
																		></input>
																		<label
																			class="form-check-label"
																			for="resolvedToggle"
																		>
																			Yes
																		</label>
																	</div>
																</td>
															</tr>
														))}

														<tr></tr>
														<tr></tr>
														<tr></tr>
														<tr></tr>

														<tr style={{ top: '50px', marginBottom: '10px' }}>
															<td colSpan={6} className="fw-bold fs-5">
																Add a new comment
															</td>
														</tr>

														<tr>
															<td>
																<input
																	type="text"
																	className="form-control"
																	value={commentFormValue.datetime}
																	disabled
																></input>
															</td>
															<td>
																<input
																	type="text"
																	className="form-control"
																	value={commentFormValue.user}
																	disabled
																></input>
															</td>
															<td className="d-flex justify-content-center">
																<select
																	name="capture-comments-type"
																	className="form-control"
																	style={{ width: '80%' }}
																	type="select"
																	value={commentFormValue.comment_type}
																	onChange={(e) =>
																		setCommentFormValue({
																			...commentFormValue,
																			comment_type: e.target.value
																		})
																	}
																>
																	{commentTypes.map((type) => (
																		<option value={type}>{type}</option>
																	))}
																</select>
																<sup>
																	<i
																		data-tooltip-id="comment-type-TT"
																		className="fa-solid fa-circle-info text-secondary mx-2"
																	></i>
																</sup>
															</td>
															<td>
																<input
																	type="text"
																	className="form-control"
																	//style={{ fontStyle: 'italic', width: '100%', border: 'solid 1px grey', borderRadius: '3px', padding: '3px' }}
																	value={commentFormValue.comment_text}
																	onChange={(e) =>
																		setCommentFormValue({
																			...commentFormValue,
																			comment_text: e.target.value
																		})
																	}
																	placeholder="Add a comment"
																></input>
															</td>

															{/* <td>
																					<select
																						name="capture-comments-type"
																						className="form-control"
																						type="select"
																						defaultValue={commentFormValue.resolved}
																					>
																						<option value={true}>True</option>
																						<option value={false}>False</option>
																					</select>
																					<sup><i
																						data-tooltip-id="comment-resolved-TT"
																						className="fa-solid fa-circle-info text-secondary mx-2"
																					></i></sup>
																				</td> */}
															<td colSpan={2}>
																<button
																	className="btn btn-small btn-secondary"
																	onClick={
																		formValid
																			? (e) => addCommentToCapture(e)
																			: undefined
																	}
																	//disabled={!formValid}
																	data-tooltip-id={
																		!formValid && 'button-not-valid-TT'
																	}
																>
																	Add comment
																</button>
																<button className="noStyleButton"></button>
															</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
									</div>
								)}
							</>
						) : siteType === 3 ? (
							<div></div>
						) : (
							<div></div>
						)}
					</div>
					<div class="modal-footer">
						<button
							type="button"
							className="btn btn-dark"
							data-bs-dismiss="modal"
							//onClick={() => setCurrentImage(null)}
						>
							Close
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default CaptureModal;
